<template>
  <a-layout-content>
    <a-form-model layout="inline">
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="代理帐号">
            <a-input v-model="qry.puid" type="text" />
          </a-form-model-item>
          <a-form-model-item label="会员帐号">
            <a-input v-model="qry.uid" type="text" />
          </a-form-model-item>
          <a-form-model-item label="IP" ref="txt_ip" prop="txt_ip">
            <a-input v-model="qry.ip" type="text" autocomplete="off" />
          </a-form-model-item>
          <a-form-model-item label="绑定状态">
            <a-select v-model="qry.bindstate" default-value="-1" style="width: 120px">
              <a-select-option value="-1">--全部--</a-select-option>
              <a-select-option value="0">未綁定</a-select-option>
              <a-select-option value="1">已綁定</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" html-type="submit" @click="query"><a-icon type="search"
                style="font-size: 20px" /></a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <div class="body-nest">
      <a-table bordered row-key="ID" size="small" :columns="columns" :data-source="userrows"
        :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :loading="loading" @change="changepage">
        <template slot="title">
          <a-row :gutter="24">
            <a-col :span="6" style="line-height: 30px">代理列表</a-col>
            <a-button type="primary" @click="batchdelete">批量删除</a-button>
            <a-button type="primary" @click="showrecommendmodel">部份修改推广地址</a-button>
            <a-button type="primary" @click="uploadBtn">批量汇入<a-icon type="upload" /></a-button>
            <a-button type="primary" @click="ExportSelectData">导出<a-icon type="download" /></a-button>
            <a-col style="float: right">
              <a-button type="primary" @click="addModal">新增代理</a-button>
            </a-col>
          </a-row>
        </template>
        <template slot="BindState" slot-scope="text, record">
          <a-tag color="cyan" v-if="record.BindState == '1'">已绑定</a-tag>
          <a-tag color="red" v-else-if="record.BindState == '0'">未绑定</a-tag>
        </template>
        <template slot="Payout" slot-scope="text, record">
          <a-tag color="cyan" v-if="record.Payout == '1'">已派发</a-tag>
          <a-tag color="red" v-else-if="record.Payout == '0'">未派发</a-tag>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-tooltip title="编辑代理">
            <a @click="editModal(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;
          <a-tooltip title="删除代理">
            <a @click="deleteagent(record)">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
      <div style="margin: 16px 0; height: 8px">
        <a-pagination style="float: right" show-size-changer :default-current="pagination.current"
          :total="pagination.total" :show-total="(total) => `共 ${total} 条`" :pageSizeOptions="pagination.sizeList"
          @change="pageNumberChange" @showSizeChange="sizeChange" />
      </div>
    </div>

    <!-------------------------------------------------------弹窗部份--------------------------------------------------------->
    <a-modal v-model="visible" title="新增/编辑代理" width="40%" ok-text="储存" cancel-text="取消" @ok="onEditSubmit">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="代理账号">
          <a-input v-model="edit.Puid" type="text" autocomplete="off" v-if="BindState==='0'||action=='add'" />
          <span v-else>{{edit.Puid}}</span>
        </a-form-model-item>
        <a-form-model-item label="会员账号" v-if="action=='edit'">
          <a-input v-model="edit.Uid" type="text" autocomplete="off" v-if="BindState==='0'" />
          <span v-else>{{edit.Uid}}</span>
        </a-form-model-item>
        <a-form-model-item label="真实姓名">
          <a-input v-model="edit.RealName" type="text" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item label="綁定狀態" v-if="action=='edit'">
          <a-select v-model="edit.BindState" style="width: 100px" default-value="0">
            <a-select-option value="0">未綁定</a-select-option>
            <a-select-option value="1">已綁定</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="申請ip" v-if="action=='edit'">
          <span>{{edit.IP}}</span>
        </a-form-model-item>
        <a-form-model-item label="推广地址">
          <a-input v-model="edit.Recommend" type="text" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="edit.Memo" :auto-size="{ minRows: 3, maxRows: 10 }" class="areaSize"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->
    <!-------------------------------------------------------上传弹窗--------------------------------------------------------->
    <a-modal v-model="uploadVisible" title="上传代理" @ok="handleUpload">
      <div style="height: 250px">
        上传后绑定状态: <a-select style="width: 120px" v-model="UpdateLoadState">
          <a-select-option value="0"> 未绑定</a-select-option>
          <a-select-option value="1"> 已绑定</a-select-option>
        </a-select>
        <br><br>
        <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button style="width:200px;"> <a-icon type="upload" /> 选择文件 </a-button>
        </a-upload>
        <br>
        <a-button type="primary" @click="dowTemplate">
          下载模板
        </a-button>
        <br><br>
        <div style="color:red">
          **请详阅以下说明!**<br>
          *1.已存在的代理账号不允许再汇入相关资讯<br>
          *2.文档中若存在重复代理账号，系统仅取第一顺位之数据<br>
          *3.推广地址请自行核实格式是否正确<br>
        </div>
        </br></br>
      </div>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->
    <!-------------------------------------------------------取代地址弹窗部份--------------------------------------------------------->
    <a-modal v-model="recommendvisible" title="部份修改推广地址" width="40%" ok-text="确认取代" cancel-text="取消"
      @ok="onReplaceSubmit">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="原始内容">
          <a-input v-model="before_recommend" type="text" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item label="取代为">
          <a-input v-model="after_recommend" type="text" autocomplete="off" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->

  </a-layout-content>
</template>

<script>
  let userrows = [];
  import XLSX from "xlsx";
  import moment from "moment";
  import { jsonExportSheet, arrayExport } from "../../js/xlsxTool";

  export default {
    data() {
      return {
        loading: false,
        visible: false,
        action: "add",
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        BindState: "0",
        UpdateLoadState: "0",
        fileList: [],
        uploadVisible: false,
        qry: {
          puid: "",
          uid: "",
          ip: "",
          bindstate: "-1",
          page: "1",
          pagesize: "10",
        },
        edit: {
          ID: "0",
          Uid: "",
          Puid: "",
          RealName: "",
          BindState: "0",
          IP: "",
          Recommend: "",
          Memo: "",
          Payout: "0",
        },
        before_recommend: "",
        after_recommend: "",
        recommendvisible: false,
        //--table --
        columns: IninTable(),
        userrows,
        selectedRowKeys: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          sizeList: ["10", "50", "500", "5000", "10000"],
        },
      };
    },
    methods: {
      query() {
        let params = {
          Uid: this.qry.uid,
          Puid: this.qry.puid,
          IP: this.qry.ip,
          BindState: this.qry.bindstate,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
        };

        this.axios.post("/agentpromotion/getagentpromotionuserlist", params).then((res) => {
          this.userrows = res.data;
          this.pagination.total = res.total;
        });

      },
      //批量选取
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      //编辑
      editModal(record) {
        this.action = 'edit';
        this.visible = true;
        this.edit.ID = record.ID;
        this.edit.Uid = record.Uid;
        this.edit.Puid = record.Puid;
        this.edit.RealName = record.RealName;
        this.edit.BindState = record.BindState.toString();
        this.edit.IP = record.IP;
        this.edit.Recommend = record.Recommend;
        this.edit.Memo = record.Memo;
        this.edit.Payout = record.Payout.toString();
      },
      addModal() {
        this.action = 'add';
        this.visible = true;
        this.edit.ID = "0";
        this.edit.Uid = '';
        this.edit.Puid = '';
        this.edit.RealName = '';
        this.edit.BindState = "0";
        this.edit.IP = '';
        this.edit.Recommend = '';
        this.edit.Memo = '';
        this.edit.Payout = "0";
      },
      onEditSubmit() {
        let _this = this;
        var urlregex = /(http|https):\/\/([\w.]+\/?)\S*/;

        if (!urlregex.test(this.edit.Recommend) && this.edit.Recommend != "") {
          return _this.$message.error(this.edit.Recommend + "请输入正确的地址");
        }

        if (this.edit.BindState == '1' && this.edit.Uid == '') {
          return _this.$message.error("未填绑定会员账号");
        }
        if (this.edit.Recommend.indexOf(' ') != -1) {
          this.$message.error("禁止有空格");
          return;
        }

        let params = {
          ID: this.edit.ID,
          Uid: this.edit.Uid,
          Puid: this.edit.Puid,
          RealName: this.edit.RealName,
          BindState: this.edit.BindState,
          IP: this.edit.IP,
          Recommend: this.edit.Recommend,
          Memo: this.edit.Memo,
          Payout: this.edit.Payout,
        };

        var _Action = this.action == "edit" ? "agentpromotionuseredit" : "agentpromotionuseradd";

        this.axios.post("/agentpromotion/" + _Action, params).then((res) => {
          if (res.data == "0") {
            this.$message.success("保存成功!");
            this.query();
          } else if (res.data == "1") {
            this.$message.error("新增失败！代理账号已存在！");
          } else {
            this.$message.error("保存失败");
          }
        });
      },
      deleteagent(record) {
        const that = this;
        this.$confirm({
          title: "删除",
          content: "您确定要删除数据吗?",
          onOk() {
            const IDList = [];
            IDList.push({ ID: record.ID });
            that.axios
              .post("/agentpromotion/agentpromotionuserdelete", {
                IDList: IDList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("删除成功");
                  that.query();
                }
              });
          },
        });
      },
      batchdelete() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量删除",
          content: "您要确定要删除勾选数据吗?",
          onOk() {
            const IDList = [];
            that.selectedRowKeys.forEach((element) => {
              IDList.push({ ID: element });
            });
            that.axios
              .post("/agentpromotion/agentpromotionuserbatchdelete", {
                IDList: IDList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("删除成功");
                  that.query();
                }
              });
          },
        });
      },
      uploadBtn() {
        this.uploadVisible = true;
        this.fileList = [];
      },
      // 下载模板
      dowTemplate() {
        var aoa = [
          ["代理账号", "会员账号", "真实姓名", "申請IP", "推广地址", "备注"],
          ["AGGTCS01(最长50)", "GTCS01(最长50)", "GTCS01(最长50)", "127.0.0.1", "", ""]
        ];
        arrayExport(aoa, "代理上传模板");
      },
      isExcel(file) {
        return /\.(xlsx|xls|csv)$/.test(file.name);
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        if (!this.isExcel(file)) {
          this.$message.error("仅支持上传.xlsx、.xls、.csv、后缀文件");
          return false;
        }
        this.fileList = [file];
        return false;
      },
      handleUpload() {
        if (this.fileList.length < 1) {
          this.$message.success("请选择文件");
          return;
        }
        const that = this;
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary", cellDates: true });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const header = that.getHeaderRow(worksheet);
            // 改变头部
            //账号 真实姓名 还款金额 还款方式 IP 备注 提交时间 审核时间
            worksheet["A1"].w = "Puid";
            worksheet["B1"].w = "Uid";
            worksheet["C1"].w = "RealName";
            worksheet["D1"].w = "IP";
            worksheet["E1"].w = "Recommend";
            worksheet["F1"].w = "Memo";
            var results = XLSX.utils.sheet_to_json(worksheet);
            this.generateData({ header, results });
            resolve();
          };
          reader.readAsArrayBuffer(that.fileList[0]);
        });
      },
      generateData({ header, results }) {
        results.forEach(element => {
          element["Puid"] = stringIsNullorEmpty(element["Puid"]) ? "" : element["Puid"].toString();
          element["Uid"] = stringIsNullorEmpty(element["Uid"]) ? "" : element["Uid"].toString();
          element["RealName"] = stringIsNullorEmpty(element["RealName"]) ? "" : element["RealName"].toString();
          element["IP"] = stringIsNullorEmpty(element["IP"]) ? "" : element["IP"].toString();
          element["Recommend"] = stringIsNullorEmpty(element["Recommend"]) ? "" : element["Recommend"].toString();
          element["Memo"] = stringIsNullorEmpty(element["Memo"]) ? "" : element["Memo"].toString();
        });

        this.axios.post("/agentpromotion/importagentpromotionuser",
          { BindState: this.UpdateLoadState, ImportAgentUser: results }
        ).then((res) => {
          if (res.data) {
            this.fileList = [];
            this.mymessage(this, "导入成功");
            this.query();
          }
          else {
            this.$message.error(res.error);
            return;
          }
        });
      },
      getHeaderRow(sheet) {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        let C;
        const R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
          let hdr = "UNKNOWN " + C;
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
          headers.push(hdr);
        }
        return headers;
      },

      //批量勾选导出
      ExportSelectData() {
        let params = {
          Uid: this.qry.uid,
          Puid: this.qry.puid,
          IP: this.qry.ip,
          BindState: this.qry.bindstate,
          pageindex: this.qry.page,
          pagesize: this.qry.pagesize,
        };

        let today = new Date();
        this.$message.success(
          "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
        );
        this.axios({
          url: "/agentpromotion/exportagentpromotionuser",
          method: "post",
          data: params,
          responseType: "blob",
        }).then((response) => {
          let blob = new Blob([response.data], { type: response.data.type });
          // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download =
              "代理会员- " + today.toISOString().split("T")[0]; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉 blob 对象
          }
        });
      },

      showrecommendmodel() {
        this.recommendvisible = true;
        this.before_recommend = "";
        this.after_recommend = "";
      },
      //取代全部地址
      onReplaceSubmit() {
        let param = {
          before_recommend: this.before_recommend.trim(),
          after_recommend: this.after_recommend.trim(),
        }
        if (param.before_recommend.indexOf(' ') != -1 || param.after_recommend.indexOf(' ') != -1) {
          this.$message.error("禁止有空格");
          return;
        }
        this.axios.post("/agentpromotion/agentpromotionuserreplaceurl", param).then((res) => {
          if (res.data) {
            this.$message.success("保存成功");
            this.recommendvisible = false;
            this.query();
          }
          else {
            this.$message.error(res.error);
            return;
          }
        });
      },
      //分页显示条数的变化
      sizeChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.query();
      },
      //分页页数的改变
      pageNumberChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.query();
      },
    },
    created() {
      this.query();
    },
  };

  function stringIsNullorEmpty(value) {
    return !value || value == undefined || value == "" || value.length == 0;
  }
  const IninTable = function IninTable() {
    var header = [];
    header.push({ title: "代理账号", align: "center", dataIndex: "Puid" });
    header.push({ title: "会员账号", align: "center", dataIndex: "Uid" });
    header.push({ title: "真实姓名", align: "center", dataIndex: "RealName" });
    header.push({
      title: "绑定状态",
      align: "center",
      dataIndex: "BindState",
      scopedSlots: { customRender: "BindState" },
    });
    header.push({ title: "IP", align: "center", dataIndex: "IP" });
    header.push({ title: "推广地址", align: "center", dataIndex: "Recommend" });
    header.push({ title: "备注", align: "center", dataIndex: "Memo" });
    header.push({
      title: "最后更新",
      align: "center",
      customRender: (text, record) => {
        text = record.Modify + " [" + record.Ldt + "]";
        return text;
      },
      sorter: (a, b) =>
        new Date(a.Ldt.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
        new Date(b.Ldt.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    });
    header.push({
      title: "操作",
      align: "center",
      dataIndex: "operation",
      ellipsis: true,
      scopedSlots: { customRender: "operation" },
      width: 100,
    });
    return header;
  };
</script>


<style>
  .areaSize {
    width: 300px;
  }
</style>


// WEBPACK FOOTER //
// src/components/agentpromotion/agentpromotionuser.vue